import React, { useState } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { black, heading3FontSize, cta1FontWeight, CollapseButton, cssColorValue, kleinBlue61, screenMdMax, screenSmMax, screenSmMin, screenXsMax, screenXxsMax, spacer16, spacer20, spacer24, spacer32, spacer40, spacer64, spacer8, Type, white } from '@spotify-internal/encore-web';
import { Link } from '../../ui';
import { HELP_LIST_TRACK_CAT, hidden } from '../util';
import { useTracking } from '../../Tracking';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var borderRadius = '6px';
var Container = styled.div.withConfig({
  displayName: "TopicGrid__Container",
  componentId: "fvy59b-0"
})(["display:flex;flex-flow:column nowrap;padding:0;margin:0;"]);
var TopicGridComponent = styled.div.withConfig({
  displayName: "TopicGrid__TopicGridComponent",
  componentId: "fvy59b-1"
})(["justify-content:center;background:", ";color:", ";width:100%;padding:", " ", " ", " ", ";@media (max-width:", "){padding:", " ", " ", " ", ";}@media (max-width:", "){padding:", " 0 ", " ", ";margin:0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.help.grayBox.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.help.grayBox.text;
}, spacer40, spacer8, spacer8, spacer40, screenSmMax, spacer40, spacer16, spacer16, spacer40, screenXsMax, spacer32, spacer16, spacer16);
var Headline = styled(Type.h2).attrs({
  paddingBottom: '0.75em',
  variant: 'alto',
  weight: 'bold'
}).withConfig({
  displayName: "TopicGrid__Headline",
  componentId: "fvy59b-2"
})(["padding:0 0 ", " 0;@media (max-width:", "){padding:0 0 ", " 0;}"], spacer40, screenXsMax, spacer32);
var Topics = styled.div.withConfig({
  displayName: "TopicGrid__Topics",
  componentId: "fvy59b-3"
})(["display:flex;flex-flow:row wrap;justify-content:flex-start;align-content:flex-start;width:100%;"]);
var Topic = styled(Link).withConfig({
  displayName: "TopicGrid__Topic",
  componentId: "fvy59b-4"
})(["display:flex;flex-flow:column nowrap;border-radius:", ";background:", ";margin:0 ", " ", " 0;padding:0;overflow:hidden;width:calc(33.33% - ", ");height:208px;@media (max-width:", "){margin:0 ", " ", " 0;width:calc(50% - ", ");}@media (max-width:", "){height:176px;}@media (max-width:", "){width:calc(100% - ", ");margin:0 0 ", " 0;}&:hover{cursor:pointer;color:unset;}&:hover h3{color:", ";}"], borderRadius, white, spacer32, spacer32, spacer32, screenMdMax, spacer24, spacer24, spacer24, screenSmMax, screenXsMax, spacer16, spacer16, cssColorValue('textSubdued'));
var TopicName = styled(Type.h3).attrs({
  variant: 'celloCanon'
}).withConfig({
  displayName: "TopicGrid__TopicName",
  componentId: "fvy59b-5"
})(["flex:0;padding:", " ", " 0 ", ";color:", ";overflow:hidden;min-height:58px;@media (max-width:", "){font-size:", ";font-weight:", ";}"], spacer20, spacer20, spacer20, kleinBlue61, screenXsMax, heading3FontSize, cta1FontWeight);
var TopicContentContainer = styled.div.withConfig({
  displayName: "TopicGrid__TopicContentContainer",
  componentId: "fvy59b-6"
})(["flex:1;display:flex;flex-flow:row nowrap;height:100%;@media (min-width:", ") and (max-width:", "),(min-width:0) and (max-width:", "){display:block;padding-right:", ";}"], screenSmMin, screenSmMax, screenXxsMax, spacer20);
var TopicTextContainer = styled.div.withConfig({
  displayName: "TopicGrid__TopicTextContainer",
  componentId: "fvy59b-7"
})(["flex:3;padding:0 0 0 ", ";max-height:112px;"], spacer20);
var TopicIconContainer = styled.div.withConfig({
  displayName: "TopicGrid__TopicIconContainer",
  componentId: "fvy59b-8"
})(["flex:1;display:flex;flex-flow:column nowrap;justify-content:flex-end;max-width:132px;@media (min-width:", ") and (max-width:", "),(min-width:0) and (max-width:", "){", "}"], screenSmMin, screenSmMax, screenXxsMax, hidden);
var TopicCount = styled(Type.p).attrs({
  variant: 'viola'
}).withConfig({
  displayName: "TopicGrid__TopicCount",
  componentId: "fvy59b-9"
})(["color:", ";padding-bottom:8px;"], cssColorValue('textSubdued'));
var TopicDescription = styled(Type.p).attrs({
  variant: 'ballad'
}).withConfig({
  displayName: "TopicGrid__TopicDescription",
  componentId: "fvy59b-10"
})([""]);
var TopicIcon = styled.img.withConfig({
  displayName: "TopicGrid__TopicIcon",
  componentId: "fvy59b-11"
})(["transform:rotate(25deg) translate(20px);"]);
var CTA = styled.div.withConfig({
  displayName: "TopicGrid__CTA",
  componentId: "fvy59b-12"
})(["display:flex;flex-flow:column;justify-content:center;align-items:center;width:100%;height:", ";background-color:", ";&:hover{cursor:pointer;}"], spacer64, cssColorValue('decorativeSubdued'));
var CTAText = styled(Type).attrs({
  variant: 'metronome'
}).withConfig({
  displayName: "TopicGrid__CTAText",
  componentId: "fvy59b-13"
})(["padding-bottom:0;text-transform:uppercase;color:", ";"], black);
export var TopicGrid = function TopicGrid(_ref3) {
  var headline = _ref3.headline,
      _ref3$items = _ref3.items,
      items = _ref3$items === void 0 ? [] : _ref3$items,
      _ref3$initialCount = _ref3.initialCount,
      initialCount = _ref3$initialCount === void 0 ? 6 : _ref3$initialCount;
  var t = useT();
  var router = useRouter();

  var _useTracking = useTracking(),
      eventHandler = _useTracking.eventHandler;

  var _useState = useState(false),
      displayAll = _useState[0],
      setDisplayAll = _useState[1];

  var seeLess = t('FRODOR_c59be2', 'See less', 'Show less information');
  var seeMore = t('FRODOR_0165e4', 'See more', 'Show more information');
  var ctaText = displayAll ? seeLess : seeMore;

  if (router && router.query && router.query._lqa === 'showSeeLess') {
    ctaText = seeLess;
  } else if (router && router.query && router.query._lqa === 'showSeeMore') {
    ctaText = seeMore;
  }

  var itemsToDisplay = displayAll ? items : items.slice(0, initialCount);

  var ctaOnClick = function ctaOnClick(e) {
    eventHandler("Frodor - ".concat(HELP_LIST_TRACK_CAT), "Topics CTA - ".concat(ctaText))(e);
    setDisplayAll(!displayAll);
  };

  return (itemsToDisplay === null || itemsToDisplay === void 0 ? void 0 : itemsToDisplay.length) && /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(TopicGridComponent, {
      "data-testid": "help-topics",
      children: [/*#__PURE__*/_jsx(Headline, {
        children: headline || t('FRODOR_TOPIC_GRID_HEADLINE', 'Browse help topics', 'Headline for help topics group')
      }), /*#__PURE__*/_jsx(Topics, {
        children: itemsToDisplay.map(function (item, key) {
          var _item$faqs, _item$icon;

          return /*#__PURE__*/_jsxs(Topic, {
            track: [HELP_LIST_TRACK_CAT, "Topics Link - ".concat(item.name)],
            href: "/help/".concat(item.urlSlug),
            children: [/*#__PURE__*/_jsx(TopicName, {
              children: item.name
            }), /*#__PURE__*/_jsxs(TopicContentContainer, {
              children: [/*#__PURE__*/_jsxs(TopicTextContainer, {
                children: [/*#__PURE__*/_jsx(TopicCount, {
                  children: t('FRODOR_TOPICS_ARTICLES', '{num} articles', 'This will be preceeded by a number', {
                    num: ((_item$faqs = item.faqs) === null || _item$faqs === void 0 ? void 0 : _item$faqs.length) || 0
                  })
                }), /*#__PURE__*/_jsx(TopicDescription, {
                  children: item.description || ''
                })]
              }), /*#__PURE__*/_jsx(TopicIconContainer, {
                children: item.icon && /*#__PURE__*/_jsx(TopicIcon, {
                  src: "".concat((_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.url),
                  "aria-hidden": true
                })
              })]
            })]
          }, key);
        })
      })]
    }), items.length > initialCount || router && router.query && router.query._lqa === 'showSeeLess' || router && router.query && router.query._lqa === 'showSeeMore' ? /*#__PURE__*/_jsx(CTA, {
      onClick: ctaOnClick,
      children: /*#__PURE__*/_jsx(CollapseButton, {
        expanded: displayAll,
        children: /*#__PURE__*/_jsx(CTAText, {
          children: ctaText
        })
      })
    }) : null]
  }) || /*#__PURE__*/_jsx(_Fragment, {});
};